import { lazy } from 'react';
import type { AppManifest } from '@/apps/types';
import { basename } from '@/fs/resolve';

/**
 * Notepad.
 *
 * Not a singleton: XP happily let you have six of them open, and the taskbar
 * grouping only makes sense if we allow that too.
 *
 * Args:
 *   file  string  path into the virtual filesystem; omitted means Untitled
 */
export const notepadApp: AppManifest = {
  id: 'notepad',
  name: 'Notepad',
  icon: '/assets/icons/notepad.svg',
  component: lazy(() => import('./Notepad')),

  defaultSize: { w: 620, h: 460 },
  minSize: { w: 300, h: 200 },
  resizable: true,
  maximizable: true,
  singleton: false,

  // `.m3u` because a playlist is a text file, and Open With ▸ Notepad on one
  // was how you found out what was actually in it.
  openWith: ['.txt', '.md', '.log', '.ini', '.m3u'],

  pinned: true,
  group: 'Accessories',

  // The component re-titles itself once the file has actually loaded; this is
  // what the title bar and the taskbar button show in the meantime.
  titleFor: (args) => `${basename(String(args.file ?? '')) || 'Untitled'} - Notepad`,
};
